import {Component, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {GetCart} from "../../cart/interface/cart-get";
import {MatDialogModule} from "@angular/material/dialog";
import {RouterLink} from "@angular/router";
import {CartDialogItemComponent} from "../cart-dialog-item/cart-dialog-item.component";
import {ApCurrency} from "../../pipe/enum/ap-currency";
import {CurrencyResolverService} from "../../currency-resolver.service";
import {CartInformationService} from "../cart-information.service";
import {CartItem} from "../interface/cart-item";
import {Product} from "../../product-details/interface/product";
import {SettingsDataService} from "../../services/settings-data.service";
import {VolumeDiscountProfileItem} from "../../product-details/interface/volume-discount-profile-item";
import {PipeModule} from "../../pipe/pipe.module";
import {isEmptyString} from "bmx-pastebox";
import {BloomsightService} from "../../bloomsight.service";
import {GlobalService} from "../../services/global.service";

@Component({
	selector: 'fb-cart-dialog',
	standalone: true,
	imports: [CommonModule, MatDialogModule, RouterLink, CartDialogItemComponent, PipeModule],
	templateUrl: './cart-dialog.component.html',
	styleUrls: ['./cart-dialog.component.scss']
})
export class CartDialogComponent implements OnInit {

	public cartItems: CartItem[] = [];
	public selectedCurrency: ApCurrency = ApCurrency.INR;
	public totalAmount: number = 0;

	constructor(
		private _currencyResolver: CurrencyResolverService,
		private _cartService: CartInformationService,
		private _setting: SettingsDataService,
		private _bloomsight: BloomsightService,
		private _userData: GlobalService
	) {
	}

	ngOnInit(): void {
		this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		this._currencyResolver.selectCurrencyChange.subscribe(() => {
			this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		});
		this._cartService.items$.subscribe(items => {
			this.totalAmount = 0;
			this.cartItems = items;
			if (this.cartItems.length > 0) {
				this.cartItems.forEach((item: CartItem) => {
					this.reCalculatePrice(item);
					if(item.calculatedDiscountPrice) {
						this.totalAmount += item.calculatedDiscountPrice * item.quantity;
					}
					else {
						this.totalAmount += (item.calculatedPrice || 0) * item.quantity;
					}
				});
				this.totalAmount = Math.round(this.totalAmount);
			}
		});
	}

	public reCalculatePrice(cartItem: CartItem): void {
		let product: Product = {} as Product;
		if(cartItem.fabricProductPreview) {
			product = cartItem.fabricProductPreview.product;
			cartItem.sku = cartItem.fabricProductPreview.product.sku;
		}
		else if(cartItem.finishedProductPreview) {
			product = cartItem.finishedProductPreview.product;
			cartItem.sku = cartItem.finishedProductPreview.product.sku;
		}
		if(cartItem.productGroup === 'swatch') {
			if(this._setting.swatchDiscount) {
				cartItem.calculatedPrice = (this._setting.swatchDiscount/100) * product.price;
			}
		}
		else {
			let selectedFabricPrice: number = 0;
			let customSizePrice: number = 0;
			let finishPrice: number = 0;
			if(cartItem.selectedFabric) {
				selectedFabricPrice = cartItem.selectedFabric.product.price;
			}
			else {
				selectedFabricPrice =  ( product.madeToOrderFabric)? product.madeToOrderFabric.price : 0;
			}
			if(cartItem.customSize && Object.keys(cartItem.customSize).length > 0 && product.customSizeProfileEnabled && product.customSizeProfile) {
				customSizePrice = product.customSizeProfile.price;
			}
			if(cartItem.selectedFinishList && cartItem.selectedFinishList.length > 0) {
				cartItem.selectedFinishList.forEach(item => finishPrice += item.price);
			}
			this._cartService.calculateCartItemPrice(cartItem, selectedFabricPrice, finishPrice, customSizePrice, product);
		}
	}

	public proceedToCheckout(): void {
		let skus: string = this.cartItems.map(item => item.sku).join();
		if (!isEmptyString(skus.replace(/,/g, '')))
			this._bloomsight.trackDataEvent(
				'65f0351efe3931befe4c46fe',
				{skus},
				''
			);

		this._bloomsight.trackDataEvent(
			'67dd7d5d5656b9d8e930c578',
			[
				{email: this._userData.customerProfileData.tenant.email},
				{userId: this._userData.customerProfileData.tenant.uid},
			],
			'Cart Popup - Proceed to Checkout'
		);
	}
}
